import { render } from "./BannerBrandingComponent.vue?vue&type=template&id=e86cd2c4"
import script from "./BannerBrandingComponent.vue?vue&type=script&lang=js"
export * from "./BannerBrandingComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__